import React from 'react';
// import __ from 'lodash';
 
class DropdownPaketProgram extends React.Component {
    render() {
        return (
            this.props.pp.map((val) =>
                <option key={val.ID_PAKET_PROGRAM} value={val.ID_PAKET_PROGRAM}>{val.NAMA_PROGRAM}</option>
            )
        )
    }
}

export default DropdownPaketProgram;